import { createSelector } from '@reduxjs/toolkit'
import { getResources } from '../../datastore'
import { IncidentWorker } from '../../datastore/models'
import { selectParamsMemo } from './helpers/selectParamsMemo'
import { selectResourcesMemo } from './helpers/selectResourcesMemo'

const selectResources = selectResourcesMemo(['incidents', 'incidentWorkers'])
const selectParams = selectParamsMemo()

export const selectIncidentWorkers = createSelector([selectResources, selectParams], (resources, params) => {
    
    const eqFilter = params.incidentId?{ incident: params.incidentId }:{}

    return getResources<IncidentWorker>(resources, 'incidentWorkers', { eqFilter })    
})
